// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"49dd0d7f","703":"905c1cb4","787":"a82dd97c"}[chunkId] + ".chunk.js";
};